export default "<div class=\"postalCode\">\n    {{CodeInComponent?.Code}} - {{CodeInComponent?.Localite}}\n</div>";